export default __webpack_public_path__ + "static/media/logoTurtle-White.0be4b600.webp";